import React, { memo } from 'react'
import { ImageContainer, Container } from './image-component-styles'

type Props = {
    src?: string
    alt?: string
    objectFit?: string
    borderRadius?: string
    paddingTop?: string
    isEager?: boolean
}

const ImageLoadingComponent: React.FC<Props> = ({ src, alt, objectFit, borderRadius, paddingTop, isEager }) => {
    return (
        <Container paddingTop={paddingTop}>
            <ImageContainer
                borderRadius={borderRadius}
                objectFit={objectFit}
                src={src}
                alt={alt}
                loading={isEager ? 'eager' : 'lazy'}
                fetchPriority={isEager ? 'high' : undefined}
                decoding={isEager ? 'sync' : 'async'}
            />
        </Container>
    )
}

export default memo(ImageLoadingComponent)
